var chunkMapping = {
	"71": [
		71
	],
	"79": [
		9079
	],
	"109": [
		6109
	],
	"125": [
		6125
	],
	"137": [
		5137
	],
	"172": [
		667,
		6085,
		8707
	],
	"182": [
		5182
	],
	"232": [
		6232
	],
	"264": [
		6264
	],
	"361": [
		5361
	],
	"383": [
		5383
	],
	"385": [
		6385
	],
	"417": [
		417
	],
	"444": [
		5444
	],
	"475": [
		6475
	],
	"635": [
		635
	],
	"806": [
		6806
	],
	"810": [
		8810
	],
	"811": [
		6811
	]
};
var idToExternalAndNameMapping = {
	"71": [
		"default",
		"./App",
		7659
	],
	"417": [
		"default",
		"./Commerce",
		9336
	],
	"635": [
		"default",
		"./Accounting",
		9336
	],
	"667": [
		"default",
		"./UserStateContext",
		8077
	],
	"5137": [
		"default",
		"./App",
		9336
	],
	"5182": [
		"default",
		"./App",
		2209
	],
	"5361": [
		"default",
		"./Link",
		331
	],
	"5383": [
		"default",
		"./Deprecations",
		8676
	],
	"5444": [
		"default",
		"./Redirects",
		331
	],
	"6085": [
		"default",
		"./IntegrationPageNameContext",
		8077
	],
	"6109": [
		"default",
		"./App",
		7020
	],
	"6125": [
		"default",
		"./Files",
		9336
	],
	"6232": [
		"default",
		"./Summary",
		9336
	],
	"6264": [
		"default",
		"./Branding",
		331
	],
	"6385": [
		"default",
		"./ProductPages",
		8676
	],
	"6475": [
		"default",
		"./IntegrationCoverage",
		8049
	],
	"6806": [
		"default",
		"./Banking",
		9336
	],
	"6811": [
		"default",
		"./App",
		8676
	],
	"8707": [
		"default",
		"./FeatureStatusContext",
		8077
	],
	"8810": [
		"default",
		"./UserManagement",
		8676
	],
	"9079": [
		"default",
		"./DataTypeSettings",
		9336
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}